module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.035a137.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.eot
// module id = 3ZDI
// module chunks = 0